import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import logoImage from '../icons/svgs_bar/logo.svg'

const styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    minWidth: 0,
    flexShrink: 0,
    margin: 0,
    padding: 0,
    border: 0,
    background: 'transparent',
    color: 'inherit',
    cursor: 'pointer',
    textDecoration: 'none',
    '&:focus': {
      outline: '2px solid rgba(255,255,255,0.7)',
      outlineOffset: 2,
    },
  },
  logo: {
    display: 'block',
    height: 32,
    maxWidth: '100%',
    '@media (max-width: 600px)': {
      width: 96,
      height: 'auto',
    },
  },
}

function InformedHeaderLogo({ classes, onClick }) {
  return (
    <button
      type="button"
      className={classes.root}
      onClick={onClick}
      aria-label="Ir para a home do Informed"
    >
      <img src={logoImage} className={classes.logo} alt="Informed" />
    </button>
  )
}

export default withStyles(styles)(InformedHeaderLogo)
